import useAuth from '@/compositions/useAuth';

const { adminLogin } = useAuth();

export default async function adminModeMiddleware(to, from, next) {
  await adminLogin(to.query);
}
